import de from "./de";

export const fallbacks = true;
export const translations = { de };
export const locale = "de";